module.exports = __webpack_public_path__ + "img/mall-loading-whatermark.74ec8025.svg";